import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { retryWhen } from 'rxjs/operators';
import { MigrationUser } from '../model/migration-user';
import { HttpClient, HttpParams } from '@angular/common/http';
import { retryStrategy, api } from '../../shared/api-loaders';
import { Transaction, TransactionFailedRecord } from '../model/Transaction';
import { RolesDisciplines } from '../../users/models/user-detail-options';
import { KeycloakImportData } from '../model/KeycloakImportData';

@Injectable({
  providedIn: 'root'
})
export class KeycloakMigrationService {

  constructor(private http: HttpClient) {  }

  public getTransactions(): Observable<Transaction[]> {
    return this.http.get<Transaction[]>(api.keycloakUsersImportTransactions()).pipe(retryWhen(retryStrategy()));
  }

  public getFailedUsers(transactionId: number): Observable<TransactionFailedRecord[]> {
    return this.http.get<TransactionFailedRecord[]>(api.keycloakImportFailedUsers(transactionId)).pipe(retryWhen(retryStrategy()));
  }

  public getReferenceData(crmId: string): Observable<RolesDisciplines[]> {
    let params = new HttpParams();
    params = params.set("crmId", crmId);
    return this.http.get<RolesDisciplines[]>(api.customerReferenceData(), { params: params }).pipe(retryWhen(retryStrategy()));
  }

  public getUsers(crmID: number, environment: number, corporation: number, inactiveUsers: boolean = false): Observable<MigrationUser[]> {
    let params = new HttpParams();
    params = params.set("envId", environment.toString());
    params = params.set("corpId", corporation.toString());
    params = params.set("crmId", crmID.toString());

    inactiveUsers = inactiveUsers ? inactiveUsers : false;
    params = params.set("inactiveUsers", inactiveUsers.toString());
    return this.http.get<MigrationUser[]>(api.keycloakUsersToImport(), { params: params }).pipe(retryWhen(retryStrategy()));
  }

  public import(data: KeycloakImportData): Observable<Object> {
    return this.http.post(api.keycloakUsersImport(), data).pipe(retryWhen(retryStrategy()));
  }
}
